/**
 * Textos del formulario Nuevo/Editar miembro (administrador, supervisor y líder).
 * Usar solo estas constantes en MemberSpiritualTabFields — no duplicar ni hardcodear por rol.
 */
export const MEMBER_ENCOUNTER_ATTENDED_LABEL = "¿Asistió al Encuentro?";
export const MEMBER_ENCOUNTER_ATTENDED_SUBTITLE = "Retiro espiritual";
export const MEMBER_MENTOR_NONE_LABEL = "Sin mentor asignado";
export const MEMBER_MENTOR_NAME_LABEL = "Nombre del Mentor";
export const MEMBER_YOUTH_CAMP_ATTENDED_LABEL = "Campamento de Jóvenes";
export const MEMBER_YOUTH_CAMP_ATTENDED_SUBTITLE = "Sí asistió / No asistió";
export const MEMBER_YOUTH_CAMP_GROUP_LABEL = "Integrado al grupo";

export const YOUTH_CAMP_GROUP_OPTIONS = [
  { value: "fuego", label: "Fuego" },
  { value: "agua", label: "Agua" },
  { value: "rocas", label: "Rocas" },
  { value: "sal", label: "Sal" },
];

/** Valor del filtro de lista: todos los asistentes al campamento (cualquier grupo). */
export const MEMBER_YOUTH_CAMP_FILTER_ALL_GROUPS = "all";

export function youthCampGroupLabel(value) {
  const norm = String(value || "").trim().toLowerCase();
  const opt = YOUTH_CAMP_GROUP_OPTIONS.find((o) => o.value === norm);
  return opt?.label || "";
}

export function youthCampAttendedExportLabel(attended) {
  return attended ? "Sí" : "";
}

/** Valores del filtro «Estado espiritual» en la lista de miembros. */
export const MEMBER_SPIRITUAL_STATUS_FILTER_NO_ENCOUNTER = "no_encuentro";
export const MEMBER_SPIRITUAL_STATUS_FILTER_NO_BAPTIZED = "no_baptized";
export const MEMBER_SPIRITUAL_STATUS_FILTER_NO_MENTOR = "no_mentor";

export const MEMBER_SPIRITUAL_STATUS_FILTER_OPTIONS = [
  {
    value: MEMBER_SPIRITUAL_STATUS_FILTER_NO_ENCOUNTER,
    label: "No asistió al Encuentro",
  },
  {
    value: MEMBER_SPIRITUAL_STATUS_FILTER_NO_BAPTIZED,
    label: "No está bautizado",
  },
  {
    value: MEMBER_SPIRITUAL_STATUS_FILTER_NO_MENTOR,
    label: "No tiene mentor",
  },
];

export function spiritualStatusFilterLabel(value) {
  const norm = String(value || "").trim();
  const opt = MEMBER_SPIRITUAL_STATUS_FILTER_OPTIONS.find((o) => o.value === norm);
  return opt?.label || "";
}

/** Única fuente para la pestaña Espiritual (evita labels duplicados o desactualizados). */
export const memberSpiritualFormLabels = {
  encounterAttended: MEMBER_ENCOUNTER_ATTENDED_LABEL,
  encounterSubtitle: MEMBER_ENCOUNTER_ATTENDED_SUBTITLE,
  mentorNone: MEMBER_MENTOR_NONE_LABEL,
  mentorName: MEMBER_MENTOR_NAME_LABEL,
  youthCampAttended: MEMBER_YOUTH_CAMP_ATTENDED_LABEL,
  youthCampAttendedSubtitle: MEMBER_YOUTH_CAMP_ATTENDED_SUBTITLE,
  youthCampGroup: MEMBER_YOUTH_CAMP_GROUP_LABEL,
};